import { Controller } from '@hotwired/stimulus'

const DEFAULT_LABELS = {
  1: 'Poor',
  2: 'Fair',
  3: 'Good',
  4: 'Great',
  5: 'Excellent'
}

const DEFAULT_HINTS = {
  1: 'Very bad experience',
  2: 'Below expectations',
  3: 'Okay delivery',
  4: 'Happy with the rider',
  5: 'Outstanding service'
}

export default class extends Controller {
  static targets = ['star', 'input', 'label', 'hint']

  connect () {
    this.paint(this.inputTarget.value)
  }

  select (event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value
    this.paint(value)
  }

  paint (value) {
    const selected = parseInt(value, 10) || 0

    this.starTargets.forEach((star, index) => {
      const active = index < selected
      star.classList.toggle('text-amber-400', active)
      star.classList.toggle('text-slate-300', !active)
      star.setAttribute('aria-pressed', active && index === selected - 1 ? 'true' : 'false')
      if (active) {
        star.classList.add('scale-110')
      } else {
        star.classList.remove('scale-110')
      }
    })

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = selected
        ? (DEFAULT_LABELS[selected] || `${selected} stars`)
        : 'Tap a star'
    }

    if (this.hasHintTarget) {
      this.hintTarget.textContent = selected
        ? (DEFAULT_HINTS[selected] || '')
        : '1 = Poor · 5 = Excellent'
    }
  }
}
